module.exports = __webpack_public_path__ + "static/img/equipamiento-six-4.031735f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/equipamiento-six-4.jpg
// module id = yzLT
// module chunks = 1